'use strict';

$ = jQuery;

$(".jc-videos").on('click', 'a', function (e) {

  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Vídeo',
    'eventAction': 'Clique - Card',
    'eventLabel': $(e.currentTarget).text().trim()
  });

  gtag('event', 'Vídeo', {
    'eventAction': 'Clique - Card',
    'eventLabel': $(e.currentTarget).text().trim()
  });

  dataLayerEstadao.push({
    'event': 'genericEvent',
    'genericCategory': 'engajamento',
    'genericAction': 'video_' + $(e.currentTarget).text().trim(),
    'genericLabel': 'clique'
  });

  gtag('event', 'engajamento', {
    'genericAction': 'video_' + $(e.currentTarget).text().trim(),
    'genericLabel': 'clique'
  });
});